import { Stack, Typography } from '@mui/material';
import React from 'react';
import { theme } from '../../../theme';
import { NumericFormat } from 'react-number-format';
import OptimizationContext from '../../PhysicianDashboard/CardItems/Optimizations/OptimizationContext';
import { ArrowForwardRounded, BoltRounded } from '@mui/icons-material';
import ItemChipSection from '../../PhysicianDashboard/CardItems/ItemChipSection';
import ItemDetail from '../../PhysicianDashboard/CardItems/ItemDetail';
import ItemSwapChipSection from '../../PhysicianDashboard/ItemSwaps/ItemSwapChipSection';

function StaffReviewItemDetails(props) {
    var optimizationText = {
        'addition': 'Add This Item',
        'removal': 'Remove This Item',
        'update': 'Adjust This Item',
    }

    var customOptimizationText = {
        'custom_removal': 'Remove This Item',
        'custom_update': 'Adjust This Item',
        'custom_addition': 'Add This Item',
    }

    function isSwap(rec) {
        return rec?.type === 'swap' || rec?.type === 'compliance' || (rec?.type === 'custom_user_edit' && rec?.status === 'custom_swap');
    }

    function isCustomEdit(rec) {
        return rec.type === 'custom_user_edit' || rec.status.split('_')[0] === 'custom';
    }

    return (
        <Stack px={2} pb={2} justifyContent='space-evenly' backgroundColor={theme.palette.background.darkGray}>
            <Stack direction='row' spacing={2}>
                <Stack p={2} spacing={1} backgroundColor='white' borderRadius='8px' width='50%'>
                    <Typography variant='bold' fontSize='14px'>Item Details</Typography>
                    <Typography variant='normal' fontSize='12px'>
                        {props.item.name}
                    </Typography>
                    <Typography variant='normal' fontSize='12px'>
                        {props.item.vendor.name} | {props.item.part_number} | <NumericFormat value={props.item.cost / 100} displayType='text' prefix='$' suffix={' / Each'} thousandSeparator={','} fixedDecimalScale decimalScale={2} />
                    </Typography>
                    { props.recommendation?.type !== 'addition' && 
                        <Stack direction='row' spacing={1} alignItems='center'>
                            <Typography variant='normal' fontSize='12px'>Original Card Qtys: </Typography>
                            <ItemDetail type='quantity' quantityType='open' data={props.item.open_quantity} />
                            <ItemDetail type='quantity' quantityType='hold' data={props.item.hold_quantity} />
                        </Stack>
                    }
                    { isSwap(props.recommendation) &&
                        <ItemSwapChipSection recommendation={props.recommendation} variant='current' />
                    }
                </Stack>
                { props.recommendation && !isCustomEdit(props.recommendation) && !isSwap(props.recommendation) &&
                    <Stack p={2} backgroundColor='white' borderRadius='8px' width='50%'>
                        <Stack direction='row' spacing={0.5} alignItems='center' pb={1.5}>
                            <BoltRounded fontSize='small' />
                            <Typography variant='heavy' sx={{ fontSize: '14px' }}>Optimization: {optimizationText[props.recommendation.type]}</Typography>
                        </Stack>
                        <ItemChipSection item={props.item} recommendation={props.recommendation} />
                        <OptimizationContext item={props.item} recommendation={props.recommendation} excludeBenefit />
                    </Stack>
                }
                { props.recommendation && isCustomEdit(props.recommendation) && !isSwap(props.recommendation) &&
                    <Stack p={2} backgroundColor='white' borderRadius='8px' width='50%'>
                        <Stack direction='row' spacing={0.5} alignItems='center' pb={1.5}>
                            <BoltRounded fontSize='small' />
                            <Typography variant='heavy' sx={{ fontSize: '14px' }}>Optimization: {customOptimizationText[props.recommendation.status]}</Typography>
                        </Stack>
                        <ItemChipSection item={props.item} recommendation={props.recommendation} />
                        <OptimizationContext item={props.item} recommendation={props.recommendation} excludeBenefit />
                    </Stack>
                }
                { isSwap(props.recommendation) &&
                    <>
                        <ArrowForwardRounded style={{ color: theme.palette.subtext.main, alignSelf: 'center' }} />
                        <Stack p={2} spacing={1} backgroundColor='white' borderRadius='8px' width='50%'>
                            <Typography variant='heavy' sx={{ fontSize: '14px' }}>New Item Details</Typography>
                            <Typography variant='normal' fontSize='12px'>
                                {props.recommendation.recommended_item.name}
                            </Typography>
                            <Typography variant='normal' fontSize='12px'>
                                {props.recommendation.recommended_item.vendor.name} | {props.recommendation.recommended_item.part_number} | <NumericFormat value={props.recommendation.recommended_item.cost / 100} displayType='text' prefix='$' suffix={' / Each'} thousandSeparator={','} fixedDecimalScale decimalScale={2} />
                            </Typography>
                            <Stack direction='row' spacing={1} alignItems='center'>
                                <Typography variant='normal' fontSize='12px'>New Card Qtys: </Typography>
                                <ItemDetail type='quantity' quantityType='open' data={props.recommendation.custom_open ?? props.recommendation.open_quantity} />
                                <ItemDetail type='quantity' quantityType='hold' data={props.recommendation.custom_hold ?? props.recommendation.hold_quantity} />
                            </Stack>
                            <ItemSwapChipSection recommendation={props.recommendation} variant='recommended' potentialSavings={props.recommendation.recommendation_value} />
                        </Stack>
                    </>
                }
            </Stack>
        </Stack>
    );
}

export default StaffReviewItemDetails;

